import { ROUTE_RESULT, ROUTE_SEARCH } from '@/router'
import {
  Form,
  FormItem,
  Button,
  Select,
  Col,
  Row,
  Option,
  Input,
  Popover,
  Tooltip
} from 'element-ui'
import { mapState } from 'vuex'
import { GET_EXHIBITION_GROUP_TYPE } from '@/store/glossary/actions'
import formsEN from '../../lang/en_GB/forms'
import formsFR from '../../lang/fr_FR/forms'

export default {
  name: 'form-simple',
  data () {
    this.$store.dispatch('glossary/' + GET_EXHIBITION_GROUP_TYPE)
    return {
      search: {
        value: '',
        type: 'exhibition',
        collection: 'all'
      }
    }
  },
  computed: {
    ...mapState({
      glossary: state => state.glossary
    }),
    exhibitionTypesOptions () {
      return [{
        id: 'all',
        typefr: formsFR.simple.data.allCollections,
        typeen: formsEN.simple.data.allCollections
      }].concat(this.glossary.exhibitionGroups)
    },
    exhibitionTypesOptionsTranslated () {
      return this.exhibitionTypesOptions.map(item => ({
        label: this.$i18n.locale === 'en_GB' ? item.typeen : item.typefr,
        value: item.id,
        id: item.id
      })).sort((a, b) => (a.id === 'all' ? -1 : (a.label > b.label ? 1 : (a.label < b.label ? -1 : 0))))
    }
  },

  methods: {
    onSubmit () {
      this.$router.push({
        name: ROUTE_RESULT,
        query: {
          collection: this.search.collection,
          value: this.search.value,
          type: this.search.type,
          page: 1
        }
      })
    },
    goToAdvancedSearch () {
      let advancedSearchRoute = {
        name: ROUTE_SEARCH
      }

      if (this.$route.query) {
        advancedSearchRoute.query = this.$route.query
      }
      this.$router.push(advancedSearchRoute)
    }
  },
  mounted () {
    if (this.$store.state.route.query) {
      const { value, type, collection } = this.$store.state.route.query
      value && (this.search.value = value)
      type && (this.search.type = type)
      collection && (this.search.collection = collection)
    }
  },
  components: {
    elForm: Form,
    elFormItem: FormItem,
    elButton: Button,
    elSelect: Select,
    elCol: Col,
    elRow: Row,
    elOption: Option,
    elInput: Input,
    elPopover: Popover,
    elTooltip: Tooltip
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/FormSimple.js